var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showDocument
    ? _c(
        "v-form",
        { ref: "systemPageForm" },
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", "order-md": "2" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-center justify-md-end" },
                        [
                          _c("action-buttons", {
                            staticClass: "d-flex justify-end",
                            attrs: {
                              state: _vm.editState,
                              permission: _vm.userPermission,
                              disabled: _vm.disableButtons,
                              "is-dirty": _vm.isDirty
                            },
                            on: {
                              save: _vm.handleSave,
                              cancel: _vm.handleCancel,
                              close: _vm.handleClose
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.id
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6", "order-md": "1" } },
                        [
                          _c("last-edit-details", {
                            attrs: { entity: _vm.doc }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.errorMessage
                ? _c(
                    "v-row",
                    { attrs: { justify: "" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-alert", { attrs: { type: "error" } }, [
                            _vm._v(" " + _vm._s(_vm.errorMessage) + " ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Plot Name",
                          rules: [_vm.requiredRule]
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Name" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.doc.name,
                          callback: function($$v) {
                            _vm.$set(_vm.doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("large-text-editor", {
                        attrs: { label: "Content", rules: [_vm.requiredRule] },
                        model: {
                          value: _vm.doc.details,
                          callback: function($$v) {
                            _vm.$set(_vm.doc, "details", $$v)
                          },
                          expression: "doc.details"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }